<app-page-wrapper [title]="dashboardTitle()" [loading]="this.state().loading" [error]="state().error">
  <ng-container *ngIf="!isDashboardEmpty(); else emptyDashboard">
    <p-card
      class="mb-6 dashboard-header-card"
    >
      <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div class="min-w-0">
          <p class="max-w-3xl text-sm leading-6 text-surface-600 dark:text-surface-300">
              {{ dashboardLead() }}
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-3">
          <span class="rounded-full bg-surface-100 px-3 py-1 text-xs font-medium text-surface-700 dark:bg-surface-800 dark:text-surface-300">
            {{ currentWeekLabel() }}
          </span>

          <div *ngIf="isOwner()" class="shrink-0">
            <p-selectButton
              [options]="dashboardModeOptions"
              [ngModel]="dashboardMode()"
              (onChange)="setDashboardMode($event.value)"
              optionLabel="label"
              optionValue="value"
              styleClass="dashboard-mode-switch"
            ></p-selectButton>
          </div>
        </div>
      </div>
    </p-card>

    <ng-container *ngIf="isOwnerTeamView()">
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
        <p-card>
          <div class="flex flex-col gap-2">
            <span class="text-surface-500 dark:text-surface-400">Łączny czas zespołu</span>
            <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
              {{ ownerTotals().totalDuration | minutesToHours: 'long' }}
            </span>
          </div>
        </p-card>

        <p-card>
          <div class="flex flex-col gap-2">
            <span class="text-surface-500 dark:text-surface-400">Łączna kwota</span>
            <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
              {{
                ownerTotals().totalRevenue | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL'
              }}
            </span>
          </div>
        </p-card>

        <p-card>
          <div class="flex flex-col gap-2">
            <span class="text-surface-500 dark:text-surface-400">Aktywni użytkownicy</span>
            <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
              {{ ownerTotals().activeUsers }} / {{ ownerTotals().totalUsers }}
            </span>
          </div>
        </p-card>

        <p-card>
          <div class="flex flex-col gap-2">
            <span class="text-surface-500 dark:text-surface-400">Średnio na aktywnego</span>
            <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
              {{ ownerTotals().averagePerActiveUser | minutesToHours: 'long' }}
            </span>
          </div>
        </p-card>
      </div>
    </ng-container>

    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 xl:col-span-8">
        <p-card class="h-full xl:min-h-[720px]">
          <div class="flex flex-col h-full">
            <div class="flex flex-row justify-between items-center gap-4 group">
              <div class="flex flex-col">
                <span class="font-medium text-lg">
                  {{
                    isOwnerTeamView()
                      ? 'Aktywność zespołu w bieżącym tygodniu'
                      : 'Podsumowanie bieżącego tygodnia'
                  }}
                </span>
              </div>

              <span
                class="opacity-60 group-hover:opacity-100 transition-opacity text-sm text-primary-600 hover:text-primary-700 dark:text-primary-300 dark:hover:text-primary-200 cursor-pointer flex items-center gap-1"
                (click)="navigateToReports()"
              >
                Zobacz w Raportach
              </span>
            </div>
            <p-divider />
            <div class="flex-1 min-h-[480px]">
              <ng-container *ngIf="hasChartData(); else emptyChart">
                <p-chart
                  type="bar"
                  [data]="chartData()"
                  [options]="chartOptions()"
                  styleClass="h-full w-full dashboard-chart"
                ></p-chart>
              </ng-container>
              <ng-template #emptyChart>
                <div class="flex h-full min-h-[480px] items-center justify-center rounded-xl border border-dashed border-surface-200 dark:border-surface-700 text-center">
                  <div class="flex max-w-sm flex-col gap-2 px-6">
                    <span class="font-medium text-surface-900 dark:text-surface-0">
                      Brak wpisów czasu w tym tygodniu
                    </span>
                    <span class="text-sm text-surface-500 dark:text-surface-400">
                      W tym miejscu pojawi się szybki wykres aktywności po dodaniu pierwszych wpisów.
                    </span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </p-card>
      </div>

      <div class="col-span-12 xl:col-span-4 flex flex-col gap-6">
        <div *ngIf="!isOwnerTeamView()" class="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <p-card>
            <div class="flex flex-col gap-2">
              <span class="text-surface-500 dark:text-surface-400">Czas</span>
              <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
                {{ dashboardData().totalPeriod?.totalDuration | minutesToHours: 'long' }}
              </span>
            </div>
          </p-card>

          <p-card>
            <div class="flex flex-col gap-2">
              <span class="text-surface-500 dark:text-surface-400">Łączna kwota</span>
              <span class="text-surface-900 dark:text-surface-0 font-semibold text-2xl">
                {{
                  dashboardData().totalPeriod?.totalRevenue
                    | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL'
                }}
              </span>
            </div>
          </p-card>
        </div>

        <p-card class="flex-1">
          <div class="flex flex-col gap-4 h-full">
            <div class="flex items-center justify-between gap-4">
                <span class="font-medium text-lg">
                  {{
                    isOwnerTeamView()
                      ? 'Projekty z największą liczbą godzin'
                      : 'Najpopularniejsze w tym tygodniu'
                  }}
                </span>

              <p-button
                *ngIf="isOwnerTeamView()"
                label="Użytkownicy"
                severity="secondary"
                [outlined]="true"
                size="small"
                (onClick)="navigateToWorkspaceUsers()"
              ></p-button>
            </div>
            <p-divider class="m-0" />

            <div class="flex flex-col gap-3 flex-1">
              <ng-container *ngIf="hasTopWorkItems(); else emptyTopItems">
                <div
                  *ngFor="let item of dashboardData().topWorkItems"
                  class="flex flex-row justify-between items-center p-3 gap-3 rounded-lg hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors"
                >
                  <div class="flex items-center truncate">
                    <span
                      class="w-1 self-stretch rounded me-3 flex-shrink-0"
                      [style.background-color]="item.color || 'var(--app-border)'"
                      [title]="'Kolor: ' + (item.color || 'brak')"
                    ></span>

                    <div class="flex items-center gap-1 truncate">
                      <span *ngIf="item.name && isOwnerTeamView()" class="font-medium truncate">
                        <a
                          [routerLink]="['/work-items', item.id]"
                          class="hover:underline text-primary-600 dark:text-primary-300"
                        >
                          {{ item.name }}
                        </a>
                      </span>
                      <span *ngIf="item.name && !isOwnerTeamView()" class="font-medium truncate">
                        {{ item.name }}
                      </span>
                      <span *ngIf="!item.name" class="font-medium truncate">
                        {{ item.clientName }}
                      </span>

                      <small *ngIf="item.name" class="text-gray-500 dark:text-gray-400 truncate">
                        {{ item.clientName ? ' - ' + item.clientName : '' }}
                      </small>
                    </div>
                  </div>
                  <span class="text-surface-500 dark:text-surface-400 font-medium">
                    {{ item.duration! | minutesToHours: 'short' }}
                  </span>
                </div>
              </ng-container>
            </div>

            <ng-template #emptyTopItems>
              <div class="flex flex-1 items-center justify-center rounded-xl border border-dashed border-surface-200 dark:border-surface-700 text-center">
                <div class="flex max-w-sm flex-col gap-2 px-6 py-10">
                  <span class="font-medium text-surface-900 dark:text-surface-0">
                    Brak danych do pokazania
                  </span>
                  <span class="text-sm text-surface-500 dark:text-surface-400">
                    Po pojawieniu się wpisów czasu najważniejsze elementy tygodnia pokażą się tutaj.
                  </span>
                </div>
              </div>
            </ng-template>
          </div>
        </p-card>
      </div>
    </div>

    <p-card *ngIf="isOwnerTeamView()" class="mt-6">
      <div class="flex flex-col gap-4">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <div class="flex flex-col gap-1">
            <span class="font-medium text-lg">Użytkownicy i godziny</span>
            <span class="text-sm text-surface-500 dark:text-surface-400">
              Szybki podgląd aktywności zespołu w bieżącym tygodniu
            </span>
          </div>

          <span class="text-sm text-surface-500 dark:text-surface-400">
            {{ ownerTotals().activeUsers }} aktywnych z {{ ownerTotals().totalUsers }}
          </span>
        </div>

        <p-divider class="m-0" />

        <div class="owner-users-list flex flex-col gap-3">
          <div
            *ngFor="let user of ownerUsers(); trackBy: trackByUserId"
            class="owner-user-row rounded-2xl border border-surface-200/50 bg-surface-0/70 p-4 shadow-none transition-colors duration-200 dark:border-surface-700/30 dark:bg-surface-900/20"
          >
            <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div class="min-w-0">
                <div class="flex flex-wrap items-center gap-2">
                  <span class="truncate font-semibold text-surface-900 dark:text-surface-0">
                    {{ user.name }}
                  </span>
                  <span
                    *ngIf="user.isCurrentUser"
                    class="rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700 dark:bg-primary-900/40 dark:text-primary-200"
                  >
                    Ty
                  </span>
                  <span
                    class="rounded-full bg-surface-100 px-2 py-0.5 text-xs font-medium text-surface-700 dark:bg-surface-800 dark:text-surface-300"
                  >
                    {{ formatRole(user.role) }}
                  </span>
                </div>

                <div class="mt-1 truncate text-sm text-surface-500 dark:text-surface-400">
                  {{ user.email }}
                </div>

                <div class="mt-3 flex flex-wrap items-center gap-2 text-sm text-surface-500 dark:text-surface-400">
                  <span class="rounded-full bg-surface-100 px-3 py-1 dark:bg-surface-800">
                    {{ user.entriesCount }} wpisów
                  </span>
                  <span class="rounded-full bg-surface-100 px-3 py-1 dark:bg-surface-800">
                    Płatne {{ user.billableDuration | minutesToHours: 'short' }}
                  </span>
                </div>
              </div>

              <div class="flex flex-col items-start gap-1 text-left sm:min-w-[160px] sm:items-end sm:text-right">
                <span class="text-xs uppercase tracking-[0.12em] text-surface-500 dark:text-surface-400">
                  Czas
                </span>
                <span class="font-semibold text-surface-900 dark:text-surface-0">
                  {{ user.totalDuration | minutesToHours: 'short' }}
                </span>
                <span class="text-xs uppercase tracking-[0.12em] text-surface-500 dark:text-surface-400">
                  Przychód
                </span>
                <span class="text-sm text-surface-600 dark:text-surface-300">
                  {{ user.totalRevenue | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </ng-container>

  <ng-template #emptyDashboard>
    <div class="flex flex-col items-center justify-center py-20 text-center">
      <i class="pi pi-chart-bar text-4xl text-gray-300 dark:text-gray-500 mb-4"></i>
      <span class="text-slate-800 dark:text-slate-50 font-semibold text-xl">
        {{
          isOwnerTeamView()
            ? 'Ups… Brak danych zespołu w tym tygodniu!'
            : 'Ups… Brak danych w tym tygodniu!'
        }}
      </span>
      <span class="app-muted mt-2">
        {{
          isOwnerTeamView()
            ? 'Dodaj użytkowników albo poczekaj na pierwsze wpisy czasu, aby zobaczyć skrót zespołu.'
            : 'Zacznij rejestrować czas pracy, aby zobaczyć statystyki.'
        }}
      </span>
      <div class="mt-4 flex flex-wrap justify-center gap-3">
        <p-button
          *ngIf="isOwnerTeamView()"
          label="Użytkownicy"
          class="px-4 py-2"
          (onClick)="navigateToWorkspaceUsers()"
          [outlined]="true"
        ></p-button>
        <p-button
          label="Rejestruj czas"
          class="px-4 py-2"
          (onClick)="navigateToTimesheet()"
          [outlined]="true"
        ></p-button>
      </div>
    </div>
  </ng-template>
</app-page-wrapper>
